import Accordion from '../functions/scripts/acc';

document.addEventListener('DOMContentLoaded', function () {
    const accordionInstance = new Accordion('[data-accordion]');

    // accordionInstance.reinit()
})